import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IProject } from '../../../models/project';
import { State } from './state';

export const getProjectsState = createFeatureSelector<State>('project');

export const getFilteredProjects = createSelector(
  getProjectsState,
  (state: State) => state.filteredProjects
);

export const getSelectedProject = createSelector(
  getProjectsState,
  (state: State) => state.selectedProject
);

export const getSelectedProjectId = createSelector(
  getProjectsState,
  (state: State) => state.selectedProject._id
);

export const getProjectTypeIdOfSelectedProject = createSelector(
  getProjectsState,
  (state: State) => state.selectedProject.projectType
);

export const getLastUsedProject = createSelector(
  getProjectsState,
  (state: State) => {
    const projects = [
      ...state.projects.filter((project) => project.pinned !== true),
    ];
    const sortedArray = projects.sort(
      (a, b) => +new Date(b.lastUsed) - +new Date(a.lastUsed)
    );
    return sortedArray.slice(0, 5);
  }
);
export const getPinnedProject = createSelector(
  getProjectsState,
  (state: State) => {
    return state.projects.filter((project) => project.pinned === true);
  }
);

export const getProjects = createSelector(
  getProjectsState,
  (state: State) => {
    return state.projects;
  }
);


export const isLoading = createSelector(
  getProjectsState,
  (state: State) => state.isLoading
);
export const isSelectedProjectLoading = createSelector(
  getProjectsState,
  (state: State) => state.isSelectedProjectLoading
);
